import { IGoalWithDatapoints } from "motw_core/Repositories/DatapointRepository";
import Player from "../../../../../../domain/Player";
import moment from "moment";

export const emptyGEPStateContainer = {
    id: 0,
    name: "",
    icon: "ammo-bag",
    startdate: moment().format(`YYYY-MM-DD`),
    daysleft: Player.initialGoalDaysLeft,
    verb: "Achieving",
    weeklyrate: 1,
    isarchived: false,
    istracking: true,
    isupper: true,
    is1time: false,
    iscommentrequired: false,
    isdaily: false,
    datapoints: [],
    energyrank: undefined,
    lastmodifiedtime: moment().local().format(),
    notes: "",
    goalhideuntildayslimit: 0,
    goalindangerdayslimit: 7,
    difficulty: 5,
    isresonating: false,
    lastresonance: null,
};

export const emptyIGEPStateContainer =
    emptyGEPStateContainer as IGoalWithDatapoints;
